import { render, staticRenderFns } from "./SimpleExamModelTable.vue?vue&type=template&id=53a89b8f&"
import script from "./SimpleExamModelTable.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports